<template>
  <div>

     <v-container>
      <v-list>
        <div v-for="item in jadwal" :key="item.id">
          <div v-if="item.value != 'TLA'">
            <v-list-item v-if="item.value != 'TLA'">
              <v-list-item-content>
              <v-list-item-title><b>{{ item.keterangan }}</b></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item v-for="item2 in item.items" :key="item2.id" @click="getDocx(item2.printout)">
              <v-list-item-content>
                <v-list-item-title>{{ item2.urut}}. {{ item2.tahap }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </div>
          
        </div>
      </v-list>
     </v-container>
  </div>
</template>

<script>
const axios = require('axios').default;

const apiUrl = process.env.VUE_APP_ROOT_API
import { format } from 'date-fns';
import { listJadwalPengadaan } from "./../../lib/viewTenderLib";

export default {
  name: 'RptHome',
  data: function() {
    return {
      aanwizjingNoArsip: "",
      jadwal : listJadwalPengadaan
      
    }
  },
  created: {
    
  },
  methods: {
    getDateFormattedDatefns: function(date) {
      return date ? format(Date.parse(date), "dd MMM yyyy HH:mm") : ''
    },
    getDocx(endpoint) {
      const url = apiUrl + endpoint; 
      axios.get(url)
        .then((response) => {
            if(response.status === 200) {
                this.getLinkDownload(response.data.file);
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    tenP1Pengumuman() {
        axios.get(`${apiUrl}/rpt/tender/p1/pengumuman`)
        .then((response) => {
            if(response.status === 200) {
                this.getLinkDownload(response.data.file);
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    tenP1AanWizjing() {
        axios.get(`${apiUrl}/rpt/tender/p1/aanwizjing`)
        .then((response) => {
            if(response.status === 200) {
                this.getLinkDownload(response.data.file);
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    tenP1PembukaanDokumenPenawaran() {
        axios.get(`${apiUrl}/rpt/tender/p1/pembukaan-dokumen-penawaran`)
        .then((response) => {
            if(response.status === 200) {
                this.getLinkDownload(response.data.file);
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    tenP1EvaluasiAdministrasiTeknisDanBiaya() {
        axios.get(`${apiUrl}/rpt/tender/p1/evaluasi-administrasi-teknis-harga-dan-kualifikasi`)
        .then((response) => {
            if(response.status === 200) {
                this.getLinkDownload(response.data.file);
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    tenP1PembuktianKualifikasi() {
        axios.get(`${apiUrl}/rpt/tender/p1/pembuktian-kualifikasi`)
        .then((response) => {
            if(response.status === 200) {
                this.getLinkDownload(response.data.file);
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    tenP1PenetapanPemenang() {
        axios.get(`${apiUrl}/rpt/tender/p1/penetapan-pemenang`)
        .then((response) => {
            if(response.status === 200) {
                this.getLinkDownload(response.data.file);
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    getLinkDownload: function(dok) {
        axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
        .then(response => {
            const blob = new Blob([response.data], { type: response.headers['content-type'] })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = dok
            link.click()
            URL.revokeObjectURL(link.href)
        }).catch(console.error)
    },
  },
}
</script>

<style>

</style>